export { PresentationCard } from './PresentationCard'
export type { IPresentationCardProps } from './PresentationCard.model'
